<!-- begin::Header -->
<header class="m-grid__item m-header display-content-on-screen" appunwraptag="">
    <!-- Mobile hamburger -->
    <button class="mobile-nav-toggle" (click)="toggleMobileMenu()" type="button" aria-label="Toggle navigation">
        <span class="mobile-hamburger-icon" [class.is-open]="isMobileMenuOpen">
            <span></span><span></span><span></span>
        </span>
    </button>
    <!-- Mobile logout (top-right) -->
    <a routerLink="/logout" class="mobile-logout-btn" aria-label="Logout" title="Logout">
        <i class="la la-power-off"></i>
    </a>
    <div class="m-header__top">
        <div class="m-container m-container--responsive m-container--xxl m-container--full-height m-page__container">
            <div class="m-stack m-stack--ver m-stack--desktop">
                <!-- begin::Brand -->
                <div class="m-stack__item m-brand p-0">
                    <div class="m-stack m-stack--ver m-stack--general m-stack--inline">
                        <div class="m-stack__item m-stack__item--middle m-brand__logo p-0">
                            <a (click)="placeWalkinOrder(false)" class="m-brand__logo-wrapper">
                                <!-- <img alt="" src="assets/demo/demo2/media/img/logo/01.png" style="height:90px; width:100px" /> -->
                                <img alt="" src="assets/images/logos/wsfx_global_pay.webp" style="height: 40px;"
                                    *ngIf="API_URL == 'https://api.wsfx.in/' " />
                                <img alt="" src="assets/images/logos/wsfx_global_pay_qa.png" style="height: 40px;"
                                    *ngIf="API_URL != 'https://api.wsfx.in/' " />
                            </a>
                        </div>
                    </div>
                </div>
                <!-- end::Brand -->

                <!-- begin::Topbar -->
                <div class="m-stack__item m-stack__item--fluid m-header-head pb-0" id="m_header_nav">
                    <div class="row">
                        <div class="col-md-9">
                            <div *ngIf="_gs.currentUser.partner.partnerStatus=='READ_ONLY'"
                                class="m-stack__item--middle m-stack__item--fluid m-header-head"
                                style="width:100%;margin-top: 15px;text-align: center;padding:5px;">
                                <span class="kyc-pending-banner">Your KYC is
                                    Pending.</span>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div id="m_header_topbar" class="m-topbar m-stack m-stack--ver m-stack--general">
                                <div class="m-stack__item m-topbar__nav-wrapper p-0">
                                    <ul class="m-topbar__nav m-nav m-nav--inline">
                                        <li class="m-nav__item m-topbar__user-profile m-topbar__user-profile--img  m-dropdown m-dropdown--medium m-dropdown--arrow m-dropdown--header-bg-fill m-dropdown--align-right m-dropdown--mobile-full-width m-dropdown--skin-light"
                                            data-dropdown-toggle="click">

                                            <a href="#" class="m-nav__link m-dropdown__toggle header-user-trigger">
                                                <span class="m-topbar__userpic m--hide">
                                                    <img src="./assets/app/media/img/users/user4.jpg"
                                                        class="m--img-rounded m--marginless m--img-centered" alt="" />
                                                </span>
                                                <span class="header-user-avatar">{{ userName?.trim().charAt(0) }}</span>
                                                <span class="m-topbar__welcome header-user-text">
                                                    <small>Hello,</small>
                                                    <strong>{{userName}}</strong>
                                                </span>
                                                <i class="m-menu__ver-arrow la la-angle-down header-user-chevron"></i>
                                                <!-- <span class="m-topbar__username"> {{userName}} </span> -->
                                            </a>

                                            <div class="m-dropdown__wrapper header-user-dropdown-wrapper">
                                                <span
                                                    class="m-dropdown__arrow m-dropdown__arrow--right m-dropdown__arrow--adjust"></span>
                                                <div class="m-dropdown__inner">
                                                    <div
                                                        class="m-dropdown__header m--align-center header-user-dropdown-header">
                                                        <div class="m-card-user m-card-user--skin-dark">
                                                            <!-- <div class="m-card-user__pic">
                                                        <img src="{{_gs.currentUser.photo}}" class="m--img-rounded m--marginless" alt="" />
                                                    </div> -->
                                                            <div class="m-card-user__details">
                                                                <span class="m-card-user__name m--font-weight-500">
                                                                    {{userName}}
                                                                </span>
                                                                <a
                                                                    class="m-card-user__email m--font-weight-300 black-text">
                                                                    {{_gs.currentUser.email}}
                                                                </a>
                                                                <br />
                                                                <a
                                                                    class="m-card-user__email m--font-weight-300 black-text">
                                                                    <b>{{_gs.currentUser.partner.name}}</b>
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="m-dropdown__body">
                                                        <div class="m-dropdown__content">
                                                            <ul class="m-nav m-nav--skin-light">
                                                                <li class="m-nav__item">
                                                                    <a routerLink="/snippets/pages/user/login-1"
                                                                        class="btn m-btn--pill btn-secondary m-btn m-btn--custom m-btn--label-brand m-btn--bolder header-logout-btn"
                                                                        routerLink="/logout">
                                                                        Logout
                                                                    </a>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>

                                    </ul>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
                <!-- end::Topbar -->
            </div>
        </div>
    </div>
    <div class="m-header__bottom ">
        <div class="m-container m-container--responsive m-container--xxl m-container--full-height m-page__container">
            <div class="m-stack m-stack--ver m-stack--desktop">
                <!-- begin::Horizontal Menu -->
                <div class="m-stack__item m-stack__item--middle m-stack__item--fluid"
                    [class.mobile-drawer-active]="isMobileMenuOpen" style="display:flex;align-items:center;">
                    <button class="m-aside-header-menu-mobile-close  m-aside-header-menu-mobile-close--skin-light"
                        id="m_aside_header_menu_mobile_close_btn" type="button" (click)="closeMobileMenu()">
                        <i class="la la-close"></i>
                    </button>
                    <div id="m_header_menu" [class.open]="isMobileMenuOpen" style="flex:1;"
                        class="m-header-menu m-aside-header-menu-mobile m-aside-header-menu-mobile--offcanvas  m-header-menu--skin-dark m-header-menu--submenu-skin-light m-aside-header-menu-mobile--skin-light m-aside-header-menu-mobile--submenu-skin-light">
                        <ul class="m-menu__nav  m-menu__nav--submenu-arrow">
                            <li class="m-menu__item  " routerLinkActive="m-menu__item--active"
                                routerLinkActiveOptions="{ exact: true }" aria-haspopup="true">
                                <a routerLink="/dashboard" class="m-menu__link">
                                    <!-- <span class="m-menu__item-here"></span> -->
                                    <span class="m-menu__link-text">
                                        <img alt="" src="assets/demo/demo2/media/img/logo/dashboard.png"
                                            style="height:12px" />
                                        Dashboard
                                    </span>
                                </a>
                            </li>
                            <li class="m-menu__item  m-menu__item--submenu m-menu__item--rel"
                                routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{ exact: true }"
                                data-menu-submenu-toggle="click" aria-haspopup="true"
                                *ngIf="uipermissionList.includes('LEADS_TAB')">
                                <a href="#" class="m-menu__link m-menu__toggle">
                                    <!-- <span class="m-menu__item-here"></span> -->
                                    <span class="m-menu__link-text">
                                        <img alt="" src="assets/demo/demo2/media/img/logo/leads.png"
                                            style="height:15px" />
                                        Leads
                                    </span>
                                    <i class="m-menu__hor-arrow la la-angle-down"></i>
                                    <i class="m-menu__ver-arrow la la-angle-right"></i>
                                </a>
                                <div class="m-menu__submenu m-menu__submenu--classic m-menu__submenu--left">
                                    <span class="m-menu__arrow m-menu__arrow--adjust"></span>
                                    <ul class="m-menu__subnav">
                                        <li class="m-menu__item" data-redirect="true" aria-haspopup="true"
                                            *ngIf="showPGLeads">
                                            <a routerLink="/leads/add" class="m-menu__link">
                                                <!-- <span class="m-menu__item-here"></span> -->
                                                <span class="m-menu__link-text">
                                                    Add New Lead
                                                </span>
                                            </a>
                                        </li>
                                        <li class="m-menu__item" data-redirect="true" aria-haspopup="true"
                                            *ngIf="showLeads">
                                            <a routerLink="/leads/addOld" class="m-menu__link">
                                                <!-- <span class="m-menu__item-here"></span> -->
                                                <span class="m-menu__link-text">
                                                    Add New Lead
                                                </span>
                                            </a>
                                        </li>
                                        <li class="m-menu__item" data-redirect="true" aria-haspopup="true"
                                            *ngIf="uipermissionList.includes('LEAD_VIEW')">
                                            <a routerLink="/leads" class="m-menu__link">
                                                <!-- <span class="m-menu__item-here"></span> -->
                                                <span class="m-menu__link-text">
                                                    View All Leads
                                                </span>
                                            </a>
                                        </li>
                                        <li class="m-menu__item" data-redirect="true" aria-haspopup="true"
                                            *ngIf="uipermissionList.includes('LEAD_VIEW')">
                                            <a routerLink="/leads/idpLeadAdd" class="m-menu__link">
                                                <!-- <span class="m-menu__item-here"></span> -->
                                                <span class="m-menu__link-text">
                                                    Add New IDP Lead
                                                </span>
                                            </a>
                                        </li>
                                        <li class="m-menu__item" data-redirect="true" aria-haspopup="true"
                                            *ngIf="uipermissionList.includes('LEAD_VIEW')">
                                            <a routerLink="/leads/idpLeadsList" class="m-menu__link">
                                                <!-- <span class="m-menu__item-here"></span> -->
                                                <span class="m-menu__link-text">
                                                    View All IDP Leads
                                                </span>
                                            </a>
                                        </li>
                                        <li class="m-menu__item" data-redirect="true" aria-haspopup="true">
                                            <a routerLink="/leads/educationLead" class="m-menu__link">
                                                <!-- <span class="m-menu__item-here"></span> -->
                                                <span class="m-menu__link-text">
                                                    Education Leads
                                                </span>
                                            </a>
                                        </li>
                                        <li class="m-menu__item" data-redirect="true" aria-haspopup="true"
                                            *ngIf="_gs.currentUser.branch.branchType == 'HO'">
                                            <a routerLink="/leads/fxcLead" class="m-menu__link">
                                                <!-- <span class="m-menu__item-here"></span> -->
                                                <span class="m-menu__link-text">
                                                    FXC Leads
                                                </span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </li>
                            <li class="m-menu__item  m-menu__item--submenu m-menu__item--rel"
                                routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{ exact: true }"
                                data-menu-submenu-toggle="click" *ngIf="uipermissionList.includes('QUOTES_TAB')"
                                aria-haspopup="true">
                                <a href="#" class="m-menu__link m-menu__toggle">
                                    <!-- <span class="m-menu__item-here"></span> -->
                                    <span class="m-menu__link-text">
                                        <img alt="" src="assets/demo/demo2/media/img/logo/orders.png"
                                            style="height:15px" />
                                        Quotes
                                    </span>
                                    <i class="m-menu__hor-arrow la la-angle-down"></i>
                                    <i class="m-menu__ver-arrow la la-angle-right"></i>
                                    <!-- <i class="m-menu__hor-arrow la la-angle-down"></i>
                                    <i class="m-menu__ver-arrow la la-angle-right"></i> -->
                                </a>
                                <div class="m-menu__submenu m-menu__submenu--classic m-menu__submenu--left">
                                    <span class="m-menu__arrow m-menu__arrow--adjust"></span>
                                    <ul class="m-menu__subnav">
                                        <li class="m-menu__item" data-redirect="true" aria-haspopup="true"
                                            *ngIf="uipermissionList.includes('ORDER_CREATE_QUOTES')">
                                            <a routerLink="/quick/sendQuote" class="m-menu__link">
                                                <!-- <span class="m-menu__item-here"></span> -->
                                                <span class="m-menu__link-text">
                                                    Send Quote
                                                </span>
                                            </a>
                                        </li>
                                        <li class="m-menu__item" data-redirect="true" aria-haspopup="true">
                                            <a routerLink="/orders/quoteorderlist" class="m-menu__link">
                                                <!-- <span class="m-menu__item-here"></span> -->
                                                <span class="m-menu__link-text">
                                                    View All Quotes
                                                </span>
                                            </a>
                                        </li>
                                        <li class="m-menu__item" data-redirect="true" aria-haspopup="true">
                                            <a routerLink="/orders/poonawalaQuotesList" class="m-menu__link">
                                                <!-- <span class="m-menu__item-here"></span> -->
                                                <span class="m-menu__link-text">
                                                    View All Poonawalla Quotes
                                                </span>
                                            </a>
                                        </li>
                                        <li class="m-menu__item" data-redirect="true" aria-haspopup="true">
                                            <a routerLink="/orders/idpQuotes" class="m-menu__link">
                                                <!-- <span class="m-menu__item-here"></span> -->
                                                <span class="m-menu__link-text">
                                                    View All IDP Quotes
                                                </span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </li>
                            <li class="m-menu__item  m-menu__item--submenu m-menu__item--rel"
                                routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{ exact: true }"
                                data-menu-submenu-toggle="click" aria-haspopup="true"
                                *ngIf="uipermissionList.includes('ORDERS_TAB')">
                                <a href="#" class="m-menu__link m-menu__toggle">
                                    <!-- <span class="m-menu__item-here"></span> -->
                                    <span class="m-menu__link-text">
                                        <img alt="" src="assets/demo/demo2/media/img/logo/orders.png"
                                            style="height:12px" />
                                        Orders
                                    </span>
                                    <i class="m-menu__hor-arrow la la-angle-down"></i>
                                    <i class="m-menu__ver-arrow la la-angle-right"></i>
                                </a>
                                <div class="m-menu__submenu m-menu__submenu--classic m-menu__submenu--left">
                                    <span class="m-menu__arrow m-menu__arrow--adjust"></span>
                                    <ul class="m-menu__subnav">
                                        <li class="m-menu__item" data-redirect="true" aria-haspopup="true"
                                            *ngIf="uipermissionList.includes('ORDER_CREATE')">
                                            <a (click)="placeWalkinOrder(false)" class="m-menu__link">
                                                <!-- <span class="m-menu__item-here"></span> -->
                                                <span class="m-menu__link-text">
                                                    Place New Order
                                                </span>
                                            </a>
                                        </li>
                                        <li class="m-menu__item" data-redirect="true" aria-haspopup="true"
                                            *ngIf="uipermissionList.includes('ORDER_CREATE_WALKIN')">
                                            <a (click)="placeWalkinOrder(true)" class="m-menu__link">
                                                <!-- <span class="m-menu__item-here"></span> -->
                                                <span class="m-menu__link-text">
                                                    Place New Walk-in Order
                                                </span>
                                            </a>
                                        </li>
                                        <li class="m-menu__item" data-redirect="true" aria-haspopup="true"
                                            *ngIf="uipermissionList.includes('ORDER_VEW_ALL')">
                                            <a routerLink="/orders" class="m-menu__link">
                                                <!-- <span class="m-menu__item-here"></span> -->
                                                <span class="m-menu__link-text">
                                                    View All Orders
                                                </span>
                                            </a>
                                        </li>
                                        <li class="m-menu__item" data-redirect="true" aria-haspopup="true"
                                            *ngIf="uipermissionList.includes('ORDER_VIEW_CREDILA')">
                                            <a routerLink="/orders/credilaorderlist" class="m-menu__link">
                                                <!-- <span class="m-menu__item-here"></span> -->
                                                <span class="m-menu__link-text">
                                                    View All Credila Orders
                                                </span>
                                            </a>
                                        </li>
                                        <li class="m-menu__item" data-redirect="true" aria-haspopup="true"
                                            *ngIf="uipermissionList.includes('ORDER_VIEW_B2C')">
                                            <a routerLink="/orders/b2corderlist" class="m-menu__link">
                                                <!-- <span class="m-menu__item-here"></span> -->
                                                <span class="m-menu__link-text">
                                                    View All B2C Orders
                                                </span>
                                            </a>
                                        </li>
                                        <li class="m-menu__item" data-redirect="true" aria-haspopup="true"
                                            *ngIf="uipermissionList.includes('ORDER_VIEW_TRAVEL_INSURANCE')">
                                            <a routerLink="/orders/travelinsuranceorderlist" class="m-menu__link">
                                                <!-- <span class="m-menu__item-here"></span> -->
                                                <span class="m-menu__link-text">
                                                    View All Old Travel Insurance Orders
                                                </span>
                                            </a>
                                        </li>
                                        <li class="m-menu__item" data-redirect="true" aria-haspopup="true">
                                            <a routerLink="/orders/newtravelinsuranceorderlist" class="m-menu__link">
                                                <span class="m-menu__link-text">
                                                    View All New Travel Insurance Orders
                                                </span>
                                            </a>
                                        </li>
                                        <li class="m-menu__item" data-redirect="true" aria-haspopup="true">
                                            <a routerLink="/orders/xplorerlist" class="m-menu__link">
                                                <span class="m-menu__link-text">
                                                    View All Xplorer Orders
                                                </span>
                                            </a>
                                        </li>
                                        <!-- <li class="m-menu__item" data-redirect="true" aria-haspopup="true"
                                            *ngIf="uipermissionList.includes('ORDER_VEW_REMITTANCE')">
                                            <a routerLink="/orders/remittanceOrders" class="m-menu__link">
                                                <span class="m-menu__link-text">
                                                    View All Remittance Orders
                                                </span>
                                            </a>
                                        </li> -->
                                        <!-- <li class="m-menu__item" data-redirect="true" aria-haspopup="true" >
                                            <a routerLink="/orders/ad1-orders" class="m-menu__link">
                                                <span class="m-menu__link-text">
                                                    View all AD1 Orders
                                                </span>
                                            </a>
                                        </li> -->

                                        <li class="m-menu__item" data-redirect="true" aria-haspopup="true"
                                            *ngIf="uipermissionList.includes('ORDER_VIEW_WALKIN')">
                                            <a routerLink="/orders/walkinorderslist" class="m-menu__link">
                                                <!-- <span class="m-menu__item-here"></span> -->
                                                <span class="m-menu__link-text">
                                                    View All Walk-in Orders
                                                </span>
                                            </a>
                                        </li>
                                        <li class="m-menu__item" data-redirect="true" aria-haspopup="true">
                                            <a routerLink="/orders/agentorderlist" class="m-menu__link">
                                                <span class="m-menu__link-text">
                                                    View All Agent Orders
                                                </span>
                                            </a>
                                        </li>
                                        <li class="m-menu__item" data-redirect="true" aria-haspopup="true">
                                            <a routerLink="/orders/fpaasOdersList" class="m-menu__link">
                                                <span class="m-menu__link-text">
                                                    View All FPaaS Orders
                                                </span>
                                            </a>
                                        </li>
                                        <li class="m-menu__item" data-redirect="true" aria-haspopup="true"
                                            *ngIf="uipermissionList.includes('ORDER_VEW_ALL')">
                                            <a routerLink="/orders/addOnOrderList" class="m-menu__link">
                                                <span class="m-menu__link-text">
                                                    View All Add-On Orders
                                                </span>
                                            </a>
                                        </li>
                                        <!-- <li class="m-menu__item" data-redirect="true" aria-haspopup="true"
                                            *ngIf="uipermissionList.includes('ORDER_VEW_ALL')">
                                            <a routerLink="/orders/xplorerOrderList" class="m-menu__link">
                                                <span class="m-menu__link-text">
                                                    View All Xplorer Orders
                                                </span>
                                            </a>
                                        </li> -->
                                        <!-- <li class="m-menu__item" data-redirect="true" aria-haspopup="true"
                                            *ngIf="uipermissionList.includes('XPLORER_CARD_REQUEST_LIST_VIEW')">
                                            <a routerLink="/orders/xplorerOrderList" class="m-menu__link">
                                                <span class="m-menu__link-text">
                                                    View All Xplorer Orders
                                                </span>
                                            </a>
                                        </li> -->
                                        <li class="m-menu__item" data-redirect="true" aria-haspopup="true"
                                            *ngIf="uipermissionList.includes('IDFC_ORDER_VIEW')">
                                            <a routerLink="/orders/idfcOrders" class="m-menu__link">
                                                <!-- <span class="m-menu__item-here"></span> -->
                                                <span class="m-menu__link-text">
                                                    View All IDFC Remit Orders
                                                </span>
                                            </a>
                                        </li>
                                        <li class="m-menu__item" data-redirect="true" aria-haspopup="true"
                                            *ngIf="uipermissionList.includes('ORDER_VEW_ALL')">
                                            <a routerLink="/orders/idpOrders" class="m-menu__link">
                                                <!-- <span class="m-menu__item-here"></span> -->
                                                <span class="m-menu__link-text">
                                                    View All IDP Orders
                                                </span>
                                            </a>
                                        </li>
                                        <!-- <li class="m-menu__item" data-redirect="true" aria-haspopup="true">
                                            <a routerLink="/orders/fpaasOdersList" class="m-menu__link">
                                                <span class="m-menu__link-text">
                                                    View All FPAAS Orders
                                                </span>
                                            </a>
                                        </li> -->
                                    </ul>
                                </div>
                            </li>

                            <li class="m-menu__item  m-menu__item--submenu m-menu__item--rel"
                                routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{ exact: true }"
                                data-menu-submenu-toggle="click" aria-haspopup="true">
                                <a href="#" class="m-menu__link m-menu__toggle">
                                    <!-- <span class="m-menu__item-here"></span> -->
                                    <span class="m-menu__link-text">
                                        <img alt="" src="assets/demo/demo2/media/img/logo/consumer.png"
                                            style="height:15px" />
                                        Consumer
                                    </span>
                                    <i class="m-menu__hor-arrow la la-angle-down"></i>
                                    <i class="m-menu__ver-arrow la la-angle-right"></i>
                                    <!-- <i class="m-menu__hor-arrow la la-angle-down"></i> -->
                                </a>
                                <div class="m-menu__submenu m-menu__submenu--classic m-menu__submenu--left">
                                    <span class="m-menu__arrow m-menu__arrow--adjust"></span>
                                    <ul class="m-menu__subnav">
                                        <li class="m-menu__item" data-redirect="true" aria-haspopup="true">
                                            <a routerLink="/admin/customer-add" class="m-menu__link">
                                                <span class="m-menu__link-text">
                                                    Add New Consumer
                                                </span>
                                            </a>
                                        </li>
                                        <li class="m-menu__item" data-redirect="true" aria-haspopup="true">
                                            <a routerLink="/admin/customer-list" class="m-menu__link">
                                                <span class="m-menu__link-text">
                                                    View All Consumers
                                                </span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </li>

                            <li class="m-menu__item  " routerLinkActive="m-menu__item--active"
                                routerLinkActiveOptions="{ exact: true }" aria-haspopup="true"
                                *ngIf="uipermissionList.includes('REPORTS_TAB') || uipermissionList.includes('REPORTS_VIEW')">
                                <a routerLink="/admin/report/location-wise" class="m-menu__link">
                                    <!-- <span class="m-menu__item-here"></span> -->
                                    <span class="m-menu__link-text">
                                        <img alt="" src="assets/demo/demo2/media/img/logo/reports.png"
                                            style="height:12px" />
                                        Reports
                                    </span>
                                </a>
                            </li>

                            <li class="m-menu__item  m-menu__item--submenu m-menu__item--rel administration-dropdown"
                                routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{ exact: true }"
                                *ngIf="uipermissionList.includes('ADMINISTRATION_TAB') "
                                data-menu-submenu-toggle="click" aria-haspopup="true">
                                <a href="#" class="m-menu__link m-menu__toggle">
                                    <!-- <span class="m-menu__item-here"></span> -->
                                    <span class="m-menu__link-text" style="font-size: 15px;">
                                        <img alt="" src="assets/demo/demo2/media/img/logo/administration.png"
                                            style="height:15px" />
                                        Administration
                                    </span>
                                    <i class="m-menu__hor-arrow la la-angle-down"></i>
                                    <!-- <i class="m-menu__ver-arrow la la-angle-right"></i> -->
                                </a>
                                <div class="m-menu__submenu m-menu__submenu--classic m-menu__submenu--left">
                                    <span class="m-menu__arrow m-menu__arrow--adjust"></span>
                                    <ul class="m-menu__subnav">
                                        <li class="m-menu__item  m-menu__item--submenu m-menu__item--rel"
                                            routerLinkActive="" routerLinkActiveOptions="{ exact: true }"
                                            data-menu-submenu-toggle="click" aria-haspopup="true"
                                            *ngIf="uipermissionList.includes('RATE_RULES_VIEW') ">
                                            <a href="#" class="m-menu__link m-menu__toggle">
                                                <!-- <span class="m-menu__item-here"></span> -->
                                                <span class="m-menu__link-text">
                                                    <!-- Currency master -->
                                                    Rate Rules
                                                </span>
                                                <i class="m-menu__hor-arrow la la-angle-right"></i>
                                                <i class="m-menu__ver-arrow la la-angle-right"></i>
                                            </a>
                                            <div id="dropdown"
                                                class="m-menu__submenu m-menu__submenu--classic m-menu__submenu--right">
                                                <span class="m-menu__arrow m-menu__arrow--adjust"></span>
                                                <ul id="dropdown-menu" class="m-menu__subnav">

                                                    <li class="m-menu__item"
                                                        *ngIf=" uipermissionList.includes('CURRENCY_MASTER_VIEW') "
                                                        data-redirect="true" aria-haspopup="true">
                                                        <a routerLink="/admin/currencymaster" class="m-menu__link">
                                                            <!--<i class="m-menu__link-icon flaticon-users"></i>-->
                                                            <span class="m-menu__link-text">
                                                                Currency Master
                                                            </span>
                                                        </a>
                                                    </li>
                                                    <li class="m-menu__item"
                                                        *ngIf="uipermissionList.includes('COMMISSION_MASTER_VIEW')"
                                                        data-redirect="true" aria-haspopup="true">
                                                        <a routerLink="/admin/commissionmaster" class="m-menu__link">
                                                            <!--<i class="m-menu__link-icon flaticon-users"></i>-->
                                                            <span class="m-menu__link-text">
                                                                Commission Master
                                                            </span>
                                                        </a>
                                                    </li>
                                                    <li class="m-menu__item" data-redirect="true" aria-haspopup="true"
                                                        *ngIf="uipermissionList.includes('DIRECT_COMMISION_MASTER_VIEW')">
                                                        <a routerLink="/admin/directCommissionMaster"
                                                            class="m-menu__link">
                                                            <!--<i class="m-menu__link-icon flaticon-users"></i>-->
                                                            <span class="m-menu__link-text">
                                                                Direct Commission Master
                                                            </span>
                                                        </a>
                                                    </li>
                                                    <li class="m-menu__item"
                                                        *ngIf="uipermissionList.includes('CHARGES_VIEW')"
                                                        data-redirect="true" aria-haspopup="true">
                                                        <a routerLink="/admin/charges" class="m-menu__link">
                                                            <!--<i class="m-menu__link-icon flaticon-users"></i>-->
                                                            <span class="m-menu__link-text">
                                                                Charges
                                                            </span>
                                                        </a>
                                                    </li>
                                                    <li class="m-menu__item"
                                                        *ngIf="uipermissionList.includes('CONSUMER_SLAB_CHARGES_VIEW')"
                                                        data-redirect="true" aria-haspopup="true">
                                                        <a routerLink="/admin/consumer-slab-charges"
                                                            class="m-menu__link">
                                                            <!--<i class="m-menu__link-icon flaticon-users"></i>-->
                                                            <span class="m-menu__link-text">
                                                                Consumer Slab Charges
                                                            </span>
                                                        </a>
                                                    </li>
                                                    <li class="m-menu__item"
                                                        *ngIf="uipermissionList.includes('EXCHANGE_RATE_MASTER_VIEW')"
                                                        data-redirect="true" aria-haspopup="true">
                                                        <a routerLink="/admin/ibr" class="m-menu__link">
                                                            <!--<i class="m-menu__link-icon flaticon-users"></i>-->
                                                            <span class="m-menu__link-text">
                                                                Exchange Rate Master
                                                            </span>
                                                        </a>
                                                    </li>

                                                    <li class="m-menu__item"
                                                        *ngIf="uipermissionList.includes('CARD_RATE_VIEW')"
                                                        data-redirect="true" aria-haspopup="true">
                                                        <a routerLink="/admin/cardrate" class="m-menu__link">
                                                            <!--<i class="m-menu__link-icon flaticon-users"></i>-->
                                                            <span class="m-menu__link-text">
                                                                Card Rate
                                                            </span>
                                                        </a>
                                                    </li>

                                                    <li class="m-menu__item"
                                                        *ngIf="uipermissionList.includes('B2C_RATE_VIEW')"
                                                        data-redirect="true" aria-haspopup="true">
                                                        <a routerLink="/admin/consumer-rate-rule" class="m-menu__link">
                                                            <!--<i class="m-menu__link-icon flaticon-users"></i>-->
                                                            <span class="m-menu__link-text">
                                                                Consumer Rate Rule
                                                            </span>
                                                        </a>
                                                    </li>

                                                    <li class="m-menu__item"
                                                        *ngIf="uipermissionList.includes('B2C_RATE_VIEW')"
                                                        data-redirect="true" aria-haspopup="true">
                                                        <a routerLink="/admin/branchwise-rate-rule"
                                                            class="m-menu__link">
                                                            <!--<i class="m-menu__link-icon flaticon-users"></i>-->
                                                            <span class="m-menu__link-text">
                                                                Branch Wise Rate Rule
                                                            </span>
                                                        </a>
                                                    </li>

                                                    <li class="m-menu__item" data-redirect="true" aria-haspopup="true"
                                                        *ngIf="uipermissionList.includes('DEAL_EXPIRY_CONFIG')">
                                                        <a routerLink="/admin/auto-deal-expiry" class="m-menu__link">
                                                            <span class="m-menu__link-text">
                                                                Auto Deal Expiry Configuration
                                                            </span>
                                                        </a>
                                                    </li>

                                                    <li class="m-menu__item" data-redirect="true" aria-haspopup="true">
                                                        <a routerLink="/admin/ibr-toggle" class="m-menu__link">
                                                            <span class="m-menu__link-text">
                                                                IBR Toggle
                                                            </span>
                                                        </a>
                                                    </li>

                                                </ul>
                                            </div>
                                        </li>
                                        <li class="m-menu__item  m-menu__item--submenu m-menu__item--rel"
                                            routerLinkActive="" routerLinkActiveOptions="{ exact: true }"
                                            data-menu-submenu-toggle="click" aria-haspopup="true">
                                            <a href="#" class="m-menu__link m-menu__toggle"
                                                *ngIf="uipermissionList.includes('USER_MANAGEMENT_VIEW')">
                                                <!-- <span class="m-menu__item-here"></span> -->
                                                <span class="m-menu__link-text">
                                                    User Management
                                                </span>
                                                <i class="m-menu__hor-arrow la la-angle-right"></i>
                                                <i class="m-menu__ver-arrow la la-angle-right"></i>
                                            </a>
                                            <div
                                                class="m-menu__submenu m-menu__submenu--classic m-menu__submenu--right">
                                                <span class="m-menu__arrow m-menu__arrow--adjust"></span>
                                                <ul class="m-menu__subnav">


                                                    <li class="m-menu__item"
                                                        *ngIf="uipermissionList.includes('PARTNERS_VIEW')"
                                                        data-redirect="true" aria-haspopup="true ">
                                                        <a routerLink="/admin/partner-list" class="m-menu__link">
                                                            <!--<i class="m-menu__link-icon flaticon-users"></i>-->
                                                            <span class="m-menu__link-text">
                                                                Partners
                                                            </span>
                                                        </a>
                                                    </li>

                                                    <li class="m-menu__item" data-redirect="true" aria-haspopup="true">
                                                        <a routerLink="/admin/partner-config" class="m-menu__link">
                                                            <span class="m-menu__link-text">
                                                                Partner Config
                                                            </span>
                                                        </a>
                                                    </li>

                                                    <li class="m-menu__item"
                                                        *ngIf=" uipermissionList.includes('CONSUMERS_TAB')"
                                                        data-redirect="true" aria-haspopup="true ">
                                                        <a routerLink="/admin/customer-list" class="m-menu__link">
                                                            <!--<i class="m-menu__link-icon flaticon-users"></i>-->
                                                            <span class="m-menu__link-text">
                                                                Consumer
                                                            </span>
                                                        </a>
                                                    </li>

                                                    <li class="m-menu__item" data-redirect="true" aria-haspopup="true"
                                                        *ngIf="_gs.currentUser.branch.branchType == 'HO' && uipermissionList.includes('BRANCHES_VIEW')">
                                                        <a routerLink="/admin/branches" class="m-menu__link">
                                                            <!--<i class="m-menu__link-icon flaticon-users"></i>-->
                                                            <span class="m-menu__link-text">
                                                                Branches
                                                            </span>
                                                        </a>
                                                    </li>

                                                    <li class="m-menu__item" data-redirect="true" aria-haspopup="true"
                                                        *ngIf="_gs.currentUser.branch.branchType == 'HO' && uipermissionList.includes('EMPLOYEES_VIEW') ">
                                                        <a routerLink="/admin/employees-list" class="m-menu__link">
                                                            <!--<i class="m-menu__link-icon flaticon-users"></i>-->
                                                            <span class="m-menu__link-text">
                                                                Employees
                                                            </span>
                                                        </a>
                                                    </li>

                                                    <li class="m-menu__item"
                                                        *ngIf="uipermissionList.includes('ROLES_VIEW')"
                                                        data-redirect="true" aria-haspopup="true">
                                                        <a routerLink="/admin/role-list" class="m-menu__link">
                                                            <span class="m-menu__link-text">
                                                                Roles
                                                            </span>
                                                        </a>
                                                    </li>
                                                    <li class="m-menu__item" data-redirect="true "
                                                        *ngIf="uipermissionList.includes('BANK_CREATION' || 'BANK_LIST' || 'BANK_EDIT')"
                                                        aria-haspopup="true">
                                                        <a routerLink="/admin/bank-account-list" class="m-menu__link">
                                                            <span class="m-menu__link-text">
                                                                Bank Account
                                                            </span>
                                                        </a>
                                                    </li>
                                                    <li class="m-menu__item" data-redirect="true "
                                                        *ngIf="uipermissionList.includes('ROLES_MANAGEMENT')"
                                                        aria-haspopup="true">
                                                        <a routerLink="/admin/otp-user-tree" class="m-menu__link">
                                                            <span class="m-menu__link-text">
                                                                Quotes OTP Approver
                                                            </span>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </li>

                                        <li class="m-menu__item  m-menu__item--submenu m-menu__item--rel"
                                            routerLinkActive="" routerLinkActiveOptions="{ exact: true }"
                                            data-menu-submenu-toggle="click" aria-haspopup="true"
                                            *ngIf="uipermissionList.includes('ROLES_AND_PERMISSION_VIEW')">
                                            <a href="#" class="m-menu__link m-menu__toggle">
                                                <!-- <span class="m-menu__item-here"></span> -->
                                                <span class="m-menu__link-text">
                                                    Roles and Permissions
                                                </span>
                                                <i class="m-menu__hor-arrow la la-angle-right"></i>
                                                <i class="m-menu__ver-arrow la la-angle-right"></i>
                                            </a>
                                            <div
                                                class="m-menu__submenu m-menu__submenu--classic m-menu__submenu--right">
                                                <span class="m-menu__arrow m-menu__arrow--adjust"></span>
                                                <ul class="m-menu__subnav">


                                                    <li class="m-menu__item" data-redirect="true" aria-haspopup="true"
                                                        *ngIf="uipermissionList.includes('ROLES_VIEW')">
                                                        <a routerLink="/admin/roles" class="m-menu__link">
                                                            <span class="m-menu__link-text">
                                                                Roles
                                                            </span>
                                                        </a>
                                                    </li>

                                                    <li class="m-menu__item" data-redirect="true" aria-haspopup="true">

                                                        <a routerLink="/admin/permission" class="m-menu__link">
                                                            <span class="m-menu__link-text">
                                                                Permission
                                                            </span>
                                                        </a>
                                                    </li>

                                                </ul>
                                            </div>
                                        </li>

                                        <li class="m-menu__item  m-menu__item--submenu m-menu__item--rel"
                                            routerLinkActive="" routerLinkActiveOptions="{ exact: true }"
                                            data-menu-submenu-toggle="click" aria-haspopup="true">
                                            <a href="#" class="m-menu__link m-menu__toggle">
                                                <span class="m-menu__link-text">
                                                    FxC Management
                                                </span>
                                                <i class="m-menu__hor-arrow la la-angle-right"></i>
                                                <i class="m-menu__ver-arrow la la-angle-right"></i>
                                            </a>
                                            <div
                                                class="m-menu__submenu m-menu__submenu--classic m-menu__submenu--right">
                                                <span class="m-menu__arrow m-menu__arrow--adjust"></span>
                                                <ul class="m-menu__subnav">
                                                    <li class="m-menu__item" data-redirect="true" aria-haspopup="true">
                                                        <a routerLink="/fxcManagement/fxc-inventory"
                                                            class="m-menu__link">
                                                            <span class="m-menu__link-text">
                                                                FxC Inventory
                                                            </span>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </li>

                                        <li class="m-menu__item  m-menu__item--submenu m-menu__item--rel"
                                            routerLinkActive="" routerLinkActiveOptions="{ exact: true }"
                                            data-menu-submenu-toggle="click" aria-haspopup="true"
                                            *ngIf=" uipermissionList.includes('REM_MANAGEMENT')">
                                            <a href="#" class="m-menu__link m-menu__toggle">
                                                <span class="m-menu__link-text">
                                                    Remittance Management
                                                </span>
                                                <i class="m-menu__hor-arrow la la-angle-right"></i>
                                                <i class="m-menu__ver-arrow la la-angle-right"></i>
                                            </a>
                                            <div
                                                class="m-menu__submenu m-menu__submenu--classic m-menu__submenu--right">
                                                <span class="m-menu__arrow m-menu__arrow--adjust"></span>
                                                <ul class="m-menu__subnav">
                                                    <li class="m-menu__item" data-redirect="true" aria-haspopup="true">
                                                        <a routerLink="/remittanceManagement/banking-circle"
                                                            class="m-menu__link">
                                                            <span class="m-menu__link-text">
                                                                Banking Circle Balances
                                                            </span>
                                                        </a>
                                                    </li>
                                                    <li class="m-menu__item" data-redirect="true" aria-haspopup="true">
                                                        <a routerLink="/remittanceManagement/checker"
                                                            class="m-menu__link">
                                                            <span class="m-menu__link-text">
                                                                Checker Queue
                                                            </span>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </li>

                                        <li class="m-menu__item  m-menu__item--submenu m-menu__item--rel"
                                            routerLinkActive="" routerLinkActiveOptions="{ exact: true }"
                                            data-menu-submenu-toggle="click" aria-haspopup="true"
                                            *ngIf=" uipermissionList.includes('MASTER_VIEW')">
                                            <a href="#" class="m-menu__link m-menu__toggle">
                                                <!-- <span class="m-menu__item-here"></span> -->
                                                <span class="m-menu__link-text">
                                                    Master
                                                </span>
                                                <i class="m-menu__hor-arrow la la-angle-right"></i>
                                                <i class="m-menu__ver-arrow la la-angle-right"></i>
                                            </a>
                                            <div
                                                class="m-menu__submenu m-menu__submenu--classic m-menu__submenu--right">
                                                <span class="m-menu__arrow m-menu__arrow--adjust"></span>
                                                <ul class="m-menu__subnav">


                                                    <li class="m-menu__item" data-redirect="true" aria-haspopup="true"
                                                        *ngIf=" uipermissionList.includes('PRODUCT_PURPOSE_DOC_VIEW') ">
                                                        <a routerLink="/admin/productPurposeDocument"
                                                            class="m-menu__link">
                                                            <span class="m-menu__link-text">
                                                                Product Purpose Document
                                                            </span>
                                                        </a>
                                                    </li>

                                                    <li class="m-menu__item" data-redirect="true" aria-haspopup="true"
                                                        *ngIf=" uipermissionList.includes('COUNTRY_MASTER_VIEW') ">
                                                        <a routerLink="/admin/countryMaster" class="m-menu__link">
                                                            <span class="m-menu__link-text">
                                                                Country Master
                                                            </span>
                                                        </a>
                                                    </li>

                                                    <li class="m-menu__item" data-redirect="true" aria-haspopup="true"
                                                        *ngIf="uipermissionList.includes('BENEFICIARY_MASTER_VIEW')">
                                                        <a routerLink="/admin/beneficiaryMaster" class="m-menu__link">
                                                            <span class="m-menu__link-text">
                                                                Beneficiary Master
                                                            </span>
                                                        </a>
                                                    </li>

                                                    <li class="m-menu__item" data-redirect="true" aria-haspopup="true"
                                                        *ngIf="uipermissionList.includes('DOCUMENT_LIST')">
                                                        <a routerLink="/admin/document-list" class="m-menu__link">
                                                            <span class="m-menu__link-text">
                                                                Documents List
                                                            </span>
                                                        </a>
                                                    </li>

                                                    <li class="m-menu__item" data-redirect="true" aria-haspopup="true">
                                                        <a routerLink="/admin/emailMobileConfig" class="m-menu__link">
                                                            <span class="m-menu__link-text">
                                                                Email Moible Master
                                                            </span>
                                                        </a>
                                                    </li>

                                                    <li class="m-menu__item" data-redirect="true" aria-haspopup="true">
                                                        <a routerLink="/admin/generalConfig" class="m-menu__link">
                                                            <span class="m-menu__link-text">
                                                                General Configuration Master
                                                            </span>
                                                        </a>
                                                    </li>

                                                    <li class="m-menu__item" data-redirect="true" aria-haspopup="true">
                                                        <a routerLink="/admin/holiday-list" class="m-menu__link">
                                                            <span class="m-menu__link-text">
                                                                Holiday
                                                            </span>
                                                        </a>
                                                    </li>
                                                    <li class="m-menu__item" data-redirect="true" aria-haspopup="true">
                                                        <a routerLink="/admin/passwordPolicy" class="m-menu__link">
                                                            <span class="m-menu__link-text">
                                                                Password Policy
                                                            </span>
                                                        </a>
                                                    </li>
                                                    <li class="m-menu__item" data-redirect="true" aria-haspopup="true">
                                                        <a routerLink="/admin/b2c-rate" class="m-menu__link">
                                                            <span class="m-menu__link-text">
                                                                B2C Rate Master
                                                            </span>
                                                        </a>
                                                    </li>
                                                    <li class="m-menu__item" data-redirect="true" aria-haspopup="true">
                                                        <a routerLink="/admin/website-page-list" class="m-menu__link">
                                                            <span class="m-menu__link-text">
                                                                Website Meta Data
                                                            </span>
                                                        </a>
                                                    </li>

                                                </ul>
                                            </div>
                                        </li>

                                        <li class="m-menu__item  m-menu__item--submenu m-menu__item--rel"
                                            routerLinkActive="m-menu__item--active"
                                            routerLinkActiveOptions="{ exact: true }" data-menu-submenu-toggle="click"
                                            *ngIf="uipermissionList.includes('BENE_APPROVAL_TAB') || uipermissionList.includes('PAYMENTS_TAB') || uipermissionList.includes('OFFERS_AND_VOUCHERS_TAB') "
                                            aria-haspopup="true">
                                            <a href="#" class="m-menu__link m-menu__toggle">
                                                <!-- <span class="m-menu__item-here"></span> -->
                                                <span class="m-menu__link-text">
                                                    <!-- <img alt="" src="assets/demo/demo2/media/img/logo/leads.png" style="height:15px" /> -->
                                                    More
                                                </span>
                                                <i class="m-menu__hor-arrow la la-angle-right"></i>
                                                <i class="m-menu__ver-arrow la la-angle-right"></i>
                                            </a>
                                            <div class="m-menu__submenu m-menu__submenu--classic m-menu__submenu--left">
                                                <span class="m-menu__arrow m-menu__arrow--adjust"></span>
                                                <ul class="m-menu__subnav">
                                                    <li class="m-menu__item" data-redirect="true" aria-haspopup="true"
                                                        *ngIf="uipermissionList.includes('BENE_APPROVAL_TAB')">
                                                        <a routerLink="/admin/beneApprove" class="m-menu__link">
                                                            <span class="m-menu__link-text">
                                                                <!-- <img alt=""
                                                                    src="assets/demo/demo2/media/img/logo/bene.png"
                                                                    style="height:12px" /> -->
                                                                Beneficiary Approval
                                                            </span>
                                                        </a>
                                                    </li>
                                                    <li class="m-menu__item" data-redirect="true" aria-haspopup="true"
                                                        *ngIf="uipermissionList.includes('PAYMENTS_TAB')">
                                                        <a routerLink="/admin/payments" class="m-menu__link">
                                                            <span class="m-menu__link-text">
                                                                <!-- <img alt=""
                                                                    src="assets/demo/demo2/media/img/logo/payments.png"
                                                                    style="height:12px" /> -->
                                                                Payments
                                                            </span>
                                                        </a>
                                                    </li>
                                                    <li class="m-menu__item  m-menu__item--submenu m-menu__item--rel"
                                                        routerLinkActive="m-menu__item--active"
                                                        routerLinkActiveOptions="{ exact: true }"
                                                        data-menu-submenu-toggle="click" aria-haspopup="true"
                                                        *ngIf="uipermissionList.includes('OFFERS_AND_VOUCHERS_TAB') ">
                                                        <a href="#" class="m-menu__link m-menu__toggle">
                                                            <!-- <span class="m-menu__item-here"></span> -->
                                                            <span class="m-menu__link-text">
                                                                <!-- <img alt=""
                                                                    src="assets/demo/demo2/media/img/logo/offers.png"
                                                                    style="height:12px" /> -->
                                                                Offers and Vouchers
                                                            </span>
                                                            <i class="m-menu__hor-arrow la la-angle-right"></i>
                                                            <i class="m-menu__ver-arrow la la-angle-right"></i>
                                                        </a>
                                                        <div
                                                            class="m-menu__submenu m-menu__submenu--classic m-menu__submenu--left">
                                                            <span class="m-menu__arrow m-menu__arrow--adjust"></span>
                                                            <ul class="m-menu__subnav">
                                                                <li class="m-menu__item" data-redirect="true"
                                                                    aria-haspopup="true"
                                                                    *ngIf="uipermissionList.includes('OFFERS_VIEW')">
                                                                    <a routerLink="/admin/offers" class="m-menu__link">
                                                                        <span class="m-menu__link-text">
                                                                            Offers
                                                                        </span>
                                                                    </a>
                                                                </li>

                                                                <li class="m-menu__item" data-redirect="true"
                                                                    aria-haspopup="true"
                                                                    *ngIf="uipermissionList.includes('SPEND_AND_EARN_OFFERS_VIEW')">
                                                                    <a routerLink="/admin/spendnearnoffers"
                                                                        class="m-menu__link">
                                                                        <span class="m-menu__link-text">
                                                                            Spend & Earn Offers
                                                                        </span>
                                                                    </a>
                                                                </li>

                                                                <li class="m-menu__item" data-redirect="true"
                                                                    aria-haspopup="true"
                                                                    *ngIf="uipermissionList.includes('EVENT_BASED_CREDITS_VIEW')">
                                                                    <a routerLink="/admin/eventBasedCredits"
                                                                        class="m-menu__link">
                                                                        <span class="m-menu__link-text">
                                                                            Event Based Credits
                                                                        </span>
                                                                    </a>
                                                                </li>

                                                                <li class="m-menu__item" data-redirect="true"
                                                                    aria-haspopup="true"
                                                                    *ngIf="uipermissionList.includes('SPEND_AND_EARN_CREDITS_VIEW')">
                                                                    <a routerLink="/admin/spendNEarnCredit"
                                                                        class="m-menu__link">
                                                                        <span class="m-menu__link-text">
                                                                            Spend & Earn Credits
                                                                        </span>
                                                                    </a>
                                                                </li>
                                                                <li class="m-menu__item" data-redirect="true"
                                                                    aria-haspopup="true"
                                                                    *ngIf="uipermissionList.includes('VOUCHERS_VIEW')">
                                                                    <a routerLink="/admin/vouchers"
                                                                        class="m-menu__link">
                                                                        <span class="m-menu__link-text">
                                                                            Vouchers
                                                                        </span>
                                                                    </a>
                                                                </li>
                                                                <li class="m-menu__item" data-redirect="true"
                                                                    aria-haspopup="true"
                                                                    *ngIf="uipermissionList.includes('CLAIMED_VOUCHERS_VIEW')">
                                                                    <a routerLink="/admin/claimVouchers"
                                                                        class="m-menu__link">
                                                                        <span class="m-menu__link-text">
                                                                            Claimed Vouchers
                                                                        </span>
                                                                    </a>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </li>
                                                    <li class="m-menu__item" data-redirect="true" aria-haspopup="true"
                                                        *ngIf="uipermissionList.includes('PAYMENTS_TAB')">
                                                        <a routerLink="/referEarn" class="m-menu__link">
                                                            <span class="m-menu__link-text">
                                                                <!-- <img alt=""
                                                                    src="assets/demo/demo2/media/img/logo/payments.png"
                                                                    style="height:12px" /> -->
                                                                Reffer and Earn
                                                            </span>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </li>

                                        <li class="m-menu__item  m-menu__item--submenu m-menu__item--rel"
                                            routerLinkActive="m-menu__item--active"
                                            routerLinkActiveOptions="{ exact: true }" data-menu-submenu-toggle="click"
                                            aria-haspopup="true">
                                            <a href="#" class="m-menu__link m-menu__toggle">
                                                <!-- <span class="m-menu__item-here"></span> -->
                                                <span class="m-menu__link-text">
                                                    Utilities
                                                </span>
                                                <i class="m-menu__hor-arrow la la-angle-right"></i>
                                                <i class="m-menu__ver-arrow la la-angle-right"></i>
                                                <!-- <i class="m-menu__hor-arrow la la-angle-down"></i> -->
                                            </a>
                                            <div class="m-menu__submenu m-menu__submenu--classic m-menu__submenu--left">
                                                <span class="m-menu__arrow m-menu__arrow--adjust"></span>
                                                <ul class="m-menu__subnav">
                                                    <li class="m-menu__item" data-redirect="true" aria-haspopup="true"
                                                        *ngIf="uipermissionList.includes('DOCUMENT_SIGN')">
                                                        <a routerLink="/admin/documentSign" class="m-menu__link">
                                                            <span class="m-menu__link-text">
                                                                Document Signing
                                                            </span>
                                                        </a>
                                                    </li>
                                                    <li class="m-menu__item" data-redirect="true" aria-haspopup="true">
                                                        <a routerLink="/admin/xl-formatting" class="m-menu__link">
                                                            <span class="m-menu__link-text">
                                                                Excel Formatting
                                                            </span>
                                                        </a>
                                                    </li>
                                                    <li class="m-menu__item" data-redirect="true" aria-haspopup="true">
                                                        <a routerLink="/admin/gp-logo-stamping" class="m-menu__link">
                                                            <span class="m-menu__link-text">
                                                                GP Logo Stamping
                                                            </span>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </li>

                                        <li class="m-menu__item" data-redirect="true" aria-haspopup="true"
                                            *ngIf="uipermissionList.includes('AML_DASHBOARD_TAB')">
                                            <a (click)="goToAMLDashboard()" class="m-menu__link">
                                                <span class="m-menu__link-text">
                                                    AML Dashboard
                                                </span>
                                            </a>
                                        </li>

                                        <li class="m-menu__item  m-menu__item--submenu m-menu__item--rel"
                                            routerLinkActive="" routerLinkActiveOptions="{ exact: true }"
                                            data-menu-submenu-toggle="click" aria-haspopup="true"
                                            *ngIf="uipermissionList.includes('CARD_OP_TAB')">
                                            <a href="#" class="m-menu__link m-menu__toggle">
                                                <!-- <span class="m-menu__item-here"></span> -->
                                                <span class="m-menu__link-text">
                                                    Card Operations
                                                </span>
                                                <i class="m-menu__hor-arrow la la-angle-right"></i>
                                                <i class="m-menu__ver-arrow la la-angle-right"></i>
                                            </a>
                                            <div
                                                class="m-menu__submenu m-menu__submenu--classic m-menu__submenu--right">
                                                <span class="m-menu__arrow m-menu__arrow--adjust"></span>
                                                <ul class="m-menu__subnav">


                                                    <li class="m-menu__item" data-redirect="true" aria-haspopup="true"
                                                        *ngIf="uipermissionList.includes('CARD_OP_VIEW')">
                                                        <a routerLink="/admin/request-card-list" class="m-menu__link">
                                                            <span class="m-menu__link-text">
                                                                Card Request List
                                                            </span>
                                                        </a>
                                                    </li>

                                                    <li class="m-menu__item" data-redirect="true" aria-haspopup="true"
                                                        *ngIf="uipermissionList.includes('CARD_OP_CREATE')">
                                                        <a routerLink="/admin/card-details" class="m-menu__link">
                                                            <span class="m-menu__link-text">
                                                                Card Operations Request
                                                            </span>
                                                        </a>
                                                    </li>
                                                    <li class="m-menu__item" data-redirect="true" aria-haspopup="true"
                                                        *ngIf="uipermissionList.includes('XPLORER_CARD_REQUEST_LIST_VIEW')">
                                                        <a routerLink="/orders/xplorerOrderList" class="m-menu__link">
                                                            <span class="m-menu__link-text">
                                                                View All Xplorer Orders
                                                            </span>
                                                        </a>
                                                    </li>

                                                    <li class="m-menu__item" data-redirect="true" aria-haspopup="true"
                                                        *ngIf="uipermissionList.includes('CARD_MANAGE_VIEW')">
                                                        <a routerLink="/admin/search-card-requests"
                                                            class="m-menu__link">
                                                            <span class="m-menu__link-text">
                                                                Card Management
                                                            </span>
                                                        </a>
                                                    </li>

                                                    <li class="m-menu__item" data-redirect="true" aria-haspopup="true"
                                                        *ngIf="uipermissionList.includes('CARD_SUPPORT_VIEW')">
                                                        <a routerLink="/admin/report/support" class="m-menu__link">
                                                            <span class="m-menu__link-text">
                                                                Card Support
                                                            </span>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </li>

                                        <li class="m-menu__item" data-redirect="true" aria-haspopup="true">
                                            <a routerLink="/admin/dreamFolks-xplorer" class="m-menu__link">
                                                <span class="m-menu__link-text">
                                                    DreamFolks Xplorer Membership ID
                                                </span>
                                            </a>
                                        </li>

                                        <li class="m-menu__item" data-redirect="true" aria-haspopup="true"
                                            *ngIf="uipermissionList.includes('ESIM_TAB')">
                                            <a routerLink="/admin/eSim-list" class="m-menu__link">
                                                <span class="m-menu__link-text">
                                                    E-SIM
                                                </span>
                                            </a>
                                        </li>

                                        <li class="m-menu__item" data-redirect="true" aria-haspopup="true"
                                            *ngIf="uipermissionList.includes('IDFC_ORDER_VIEW')">
                                            <a (click)="goToIDFCBulkUpload()" class="m-menu__link">
                                                <span class="m-menu__link-text">
                                                    IDFC Remit - Bulk Upload
                                                </span>
                                            </a>
                                        </li>
                                        <li class="m-menu__item"
                                            *ngIf="uipermissionList.includes('GENERATE_CLAIM_VIEW')"
                                            data-redirect="true" aria-haspopup="true">
                                            <a routerLink="/admin/partner-invoice" class="m-menu__link">
                                                <!--<i class="m-menu__link-icon flaticon-users"></i>-->
                                                <span class="m-menu__link-text">
                                                    Generate Commission
                                                </span>
                                            </a>
                                        </li>

                                        <li class="m-menu__item" data-redirect="true" aria-haspopup="true"
                                            *ngIf="uipermissionList.includes('APP_NOTIFICATION_VIEW')">
                                            <a routerLink="/admin/notification" class="m-menu__link">
                                                <span class="m-menu__link-text">
                                                    App Notification
                                                </span>
                                            </a>
                                        </li>

                                        <li class="m-menu__item" data-redirect="true" aria-haspopup="true"
                                            *ngIf="uipermissionList.includes('TICKETS_VIEW') ">
                                            <a routerLink="/admin/ticket-list" class="m-menu__link">
                                                <span class="m-menu__link-text">
                                                    Tickets
                                                </span>
                                            </a>
                                        </li>
                                        <li class="m-menu__item" *ngIf="uipermissionList.includes('PAN_VERIFICATION') "
                                            data-redirect="true" aria-haspopup="true">
                                            <a routerLink="/admin/PanVarify" class="m-menu__link">
                                                <!--<i class="m-menu__link-icon flaticon-users"></i>-->
                                                <span class="m-menu__link-text">
                                                    PAN Verification
                                                </span>
                                            </a>
                                        </li>
                                        <li class="m-menu__item" data-redirect="true"
                                            *ngIf="uipermissionList.includes('VIEW_FORMS')" aria-haspopup="true">
                                            <a routerLink="/admin/forms" class="m-menu__link">
                                                <!--<i class="m-menu__link-icon flaticon-users"></i>-->
                                                <span class="m-menu__link-text">
                                                    View Forms
                                                </span>
                                            </a>
                                        </li>
                                        <li class="m-menu__item" data-redirect="true"
                                            *ngIf="uipermissionList.includes('MIGRATED_VCIP_RECORDS')"
                                            aria-haspopup="true">
                                            <a routerLink="/admin/vkyc-migration-record" class="m-menu__link">
                                                <!--<i class="m-menu__link-icon flaticon-users"></i>-->
                                                <span class="m-menu__link-text">
                                                    Migrated VCIP records
                                                </span>
                                            </a>
                                        </li>

                                    </ul>
                                </div>
                            </li>
                            <li class="m-menu__item  m-menu__item--submenu m-menu__item--rel"
                                *ngIf="cdpUipermissionList.includes('CDP_TAB')" routerLinkActive="m-menu__item--active"
                                routerLinkActiveOptions="{ exact: true }" data-menu-submenu-toggle="click"
                                aria-haspopup="true">
                                <a href="#" class="m-menu__link m-menu__toggle">
                                    <!-- <span class="m-menu__item-here"></span> -->
                                    <span class="m-menu__link-text">
                                        <!-- <img alt="" src="assets/demo/demo2/media/img/logo/consumer.png"
                                                        style="height:15px" /> -->
                                        Card Distribution
                                    </span>
                                    <i class="m-menu__hor-arrow la la-angle-down"></i>
                                    <i class="m-menu__ver-arrow la la-angle-right"></i>
                                    <!-- <i class="m-menu__hor-arrow la la-angle-down"></i> -->
                                </a>
                                <div class="m-menu__submenu m-menu__submenu--classic">
                                    <span class="m-menu__arrow m-menu__arrow--adjust"></span>
                                    <ul class="m-menu__subnav">
                                        <li class="m-menu__item  m-menu__item--submenu m-menu__item--rel"
                                            routerLinkActive="m-menu__item--active"
                                            *ngIf="cdpUipermissionList.includes('CDP_PARTNER_ONBOARD_TAB')"
                                            routerLinkActiveOptions="{ exact: true }" data-menu-submenu-toggle="click"
                                            aria-haspopup="true">
                                            <a href="#" class="m-menu__link m-menu__toggle">
                                                <!-- <span class="m-menu__item-here"></span> -->
                                                <span class="m-menu__link-text">
                                                    Partner Onboard
                                                </span>
                                                <i class="m-menu__hor-arrow la la-angle-right"></i>
                                                <i class="m-menu__ver-arrow la la-angle-right"></i>
                                                <!-- <i class="m-menu__hor-arrow la la-angle-down"></i> -->
                                            </a>
                                            <div
                                                class="m-menu__submenu cd m-menu__submenu--classic m-menu__submenu--left">
                                                <span class="m-menu__arrow m-menu__arrow--adjust"></span>
                                                <ul class="m-menu__subnav">
                                                    <li class="m-menu__item" data-redirect="true" aria-haspopup="true"
                                                        *ngIf="cdpUipermissionList.includes('CDP_PARTNERS_LIST_TAB')">
                                                        <a routerLink="/cardDistribution/partners-list"
                                                            class="m-menu__link">
                                                            <span class="m-menu__link-text">
                                                                Partner
                                                            </span>
                                                        </a>
                                                    </li>
                                                    <li class="m-menu__item" data-redirect="true" aria-haspopup="true"
                                                        *ngIf="cdpUipermissionList.includes('CDP_COMMERCIAL_CONFIG_TAB')">
                                                        <a routerLink="/cardDistribution/commercials-list"
                                                            class="m-menu__link">
                                                            <span class="m-menu__link-text">
                                                                Commercial Configuration
                                                            </span>
                                                        </a>
                                                    </li>
                                                    <li class="m-menu__item" data-redirect="true" aria-haspopup="true"
                                                        *ngIf="cdpUipermissionList.includes('CDP_USERS_LIST_TAB')">
                                                        <a routerLink="/cardDistribution/users-list"
                                                            class="m-menu__link">
                                                            <span class="m-menu__link-text">
                                                                User Mapping
                                                            </span>
                                                        </a>
                                                    </li>
                                                    <li class="m-menu__item" data-redirect="true" aria-haspopup="true"
                                                        *ngIf="cdpUipermissionList.includes('CDP_BRANCHES_LIST_TAB')">
                                                        <!-- *ngIf="uipermissionList.includes('CDP_BRANCHES_LIST_TAB')"
                                                                    > -->
                                                        <a routerLink="/cardDistribution/cdp-branches-list"
                                                            class="m-menu__link">
                                                            <span class="m-menu__link-text">
                                                                Branch Mapping
                                                            </span>
                                                        </a>
                                                    </li>
                                                    <li class="m-menu__item" data-redirect="true" aria-haspopup="true"
                                                        *ngIf="cdpUipermissionList.includes('CDP_BANKS_LIST_TAB')">
                                                        <!-- *ngIf="uipermissionList.includes('CDP_BANKS_LIST_TAB')"> -->
                                                        <a routerLink="/cardDistribution/cdp-banks-list"
                                                            class="m-menu__link">
                                                            <span class="m-menu__link-text">
                                                                Bank Account Mapping
                                                            </span>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </li>
                                        <li class="m-menu__item m-menu__item--submenu m-menu__item--rel"
                                            routerLinkActive="m-menu__item--active"
                                            *ngIf="cdpUipermissionList.includes('CDP_TRANSACTIONS_TAB')"
                                            routerLinkActiveOptions="{ exact: true }" data-menu-submenu-toggle="click"
                                            aria-haspopup="true">
                                            <a href="#" class="m-menu__link m-menu__toggle">
                                                <!-- <span class="m-menu__item-here"></span> -->
                                                <span class="m-menu__link-text">
                                                    Transaction
                                                </span>
                                                <i class="m-menu__hor-arrow la la-angle-right"></i>
                                                <i class="m-menu__ver-arrow la la-angle-right"></i>
                                                <!-- <i class="m-menu__hor-arrow la la-angle-down"></i> -->
                                            </a>
                                            <div
                                                class="m-menu__submenu cd m-menu__submenu--classic m-menu__submenu--left">
                                                <span class="m-menu__arrow m-menu__arrow--adjust"></span>
                                                <ul class="m-menu__subnav">
                                                    <li class="m-menu__item" data-redirect="true" aria-haspopup="true">
                                                        <a routerLink="/cardDistribution/load-transactions-list"
                                                            class="m-menu__link">
                                                            <span class="m-menu__link-text">
                                                                Load Transaction
                                                            </span>
                                                        </a>
                                                    </li>
                                                    <li class="m-menu__item" data-redirect="true" aria-haspopup="true">
                                                        <a routerLink="/cardDistribution/reload-transactions-list"
                                                            class="m-menu__link">
                                                            <span class="m-menu__link-text">
                                                                Reload Transaction
                                                            </span>
                                                        </a>
                                                    </li>
                                                    <li class="m-menu__item" data-redirect="true" aria-haspopup="true">
                                                        <a routerLink="/cardDistribution/refund-transactions-list"
                                                            class="m-menu__link">
                                                            <span class="m-menu__link-text">
                                                                Refund Transaction

                                                            </span>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </li>
                                        <li class="m-menu__item" data-redirect="true" aria-haspopup="true"
                                            *ngIf="cdpUipermissionList.includes('CDP_INVENTORY_TAB')">
                                            <a routerLink="/cardDistribution/inventory-management" class="m-menu__link">
                                                <span class="m-menu__link-text">
                                                    Inventory Module
                                                </span>
                                            </a>
                                        </li>
                                        <li class="m-menu__item" data-redirect="true" aria-haspopup="true"
                                            *ngIf="uipermissionList.includes('CDP_DEALS_TAB')">
                                            <a routerLink="/cardDistribution/deals-list" class="m-menu__link">
                                                <span class="m-menu__link-text">
                                                    Deals List
                                                </span>
                                            </a>
                                        </li>
                                        <li class="m-menu__item" data-redirect="true" aria-haspopup="true"
                                            *ngIf="uipermissionList.includes('CDP_ADVANCE_TAB')">
                                            <a routerLink="/cardDistribution/advance" class="m-menu__link">
                                                <span class="m-menu__link-text">
                                                    Advance
                                                </span>
                                            </a>
                                        </li>
                                        <li class="m-menu__item" data-redirect="true" aria-haspopup="true"
                                            *ngIf="cdpUipermissionList.includes('CDP_CARD_MANAGEMENT_TAB')">
                                            <a routerLink="/admin/search-card-requests"
                                                [queryParams]="{ isFromCdp: true }" class="m-menu__link">
                                                <span class="m-menu__link-text">
                                                    Distribution Card Management
                                                </span>
                                            </a>
                                        </li>

                                        <li class="m-menu__item" data-redirect="true" aria-haspopup="true"
                                            *ngIf="cdpUipermissionList.includes('CDP_REPORTS_TAB')">
                                            <a routerLink="/cardDistribution/cdp-reports" class="m-menu__link">
                                                <span class="m-menu__link-text">
                                                    Reports
                                                </span>
                                            </a>
                                        </li>

                                        <li class="m-menu__item" data-redirect="true" aria-haspopup="true"
                                            *ngIf="cdpUipermissionList.includes('CDP_REPORTS_TAB')">
                                            <a routerLink="/cardDistribution/card-dashboard" class="m-menu__link">
                                                <span class="m-menu__link-text">
                                                    CDP Dashboard
                                                </span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </li>
                            <!-- Ad 1 -->
                            <!-- <li class="m-menu__item  m-menu__item--submenu m-menu__item--rel" routerLinkActive="m-menu__item--active" routerLinkActiveOptions="{ exact: true }" data-menu-submenu-toggle="click" aria-haspopup="true" 
                               >
                                <a href="#" class="m-menu__link m-menu__toggle">
                                    <span class="m-menu__link-text">
                                        AD 1
                                    </span>
                                    <i class="m-menu__hor-arrow la la-angle-down"></i>
                                </a>
                                <div class="m-menu__submenu m-menu__submenu--classic m-menu__submenu--left">
                                    <span class="m-menu__arrow m-menu__arrow--adjust"></span>
                                    <ul class="m-menu__subnav">
                                        <li class="m-menu__item" data-redirect="true" aria-haspopup="true" >
                                            <a routerLink="/admin/bank-cover" class="m-menu__link">
                                                
                                                <span class="m-menu__link-text">
                                                   Bank Cover
                                                </span>
                                            </a>
                                        </li>
                                        <li class="m-menu__item" data-redirect="true" aria-haspopup="true" >
                                            <a routerLink="/admin/deMap-bank-cover" class="m-menu__link">
                                                
                                                <span class="m-menu__link-text">
                                                    De-Map Bank Cover
                                                </span>
                                            </a>
                                        </li>
                                        <li class="m-menu__item" data-redirect="true" aria-haspopup="true">
                                            <a routerLink="/admin/verification" class="m-menu__link">
                                              
                                                <span class="m-menu__link-text">
                                                    Verification
                                                </span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </li> -->
                            <!--  -->
                        </ul>
                    </div>
                    <div class="header-action-buttons">
                        <button class="btn btn-sm btn-accent m-btn m-btn--custom m-btn--icon  m-btn--pill" type="button"
                            *ngIf="uipermissionList.includes('ORDER_CREATE_QUOTES') && !isTourAgent"
                            routerLink="/quick/sendQuote">
                            Send Quote
                        </button>
                        <button
                            class="btn btn-sm btn-accent m-btn m-btn--custom m-btn--icon  m-btn--pill header-btn-primary"
                            type="button" (click)="placeWalkinOrder(false)"
                            *ngIf="uipermissionList.includes('ORDER_CREATE')">
                            Place Order
                        </button>
                    </div>
                    <style>

                    </style>
                </div>
                <!-- end::Horizontal Menu -->
            </div>
        </div>
    </div>
</header>
<!-- Mobile drawer overlay (outside the header so it stacks below the drawer) -->
<div class="mobile-nav-overlay" [class.active]="isMobileMenuOpen" (click)="closeMobileMenu()"></div>
<!-- end::Header -->


// WEBPACK FOOTER //
// ./src/app/core/layouts/header-nav/header-nav.component.html